import axios from 'axios';

// In dev: CRA proxies /api to localhost:3001
// In prod: REACT_APP_API_URL points to the Render backend
const BASE_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api`
  : '/api';

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 120000,
});

// JWT interceptor is registered in AuthContext to ensure it runs after session is loaded.
// This file just exports the configured axios instance.

// ── Profiles ──────────────────────────────────────────────────────────────────
export const getProfiles = () => api.get('/profiles').then(r => r.data);
export const updateProfile = (id, data) => api.patch('/profiles/me', data).then(r => r.data);

// ── Projects ──────────────────────────────────────────────────────────────────
export const getProjects = () => api.get('/projects').then(r => r.data);
export const getProject = (id) => api.get(`/projects/${id}`).then(r => r.data);
export const createProject = (data) => api.post('/projects', data).then(r => r.data);
export const updateProject = (id, data) => api.patch(`/projects/${id}`, data).then(r => r.data);
export const appendScope = (id, note) => api.patch(`/projects/${id}/scope`, { note }).then(r => r.data);
export const appendSectionNote = (id, section, note) => api.patch(`/projects/${id}/section-note`, { section, note }).then(r => r.data);
export const deleteProject = (id) => api.delete(`/projects/${id}`).then(r => r.data);

// ── Upload ────────────────────────────────────────────────────────────────────
export const uploadScope = (formData) =>
  api.post('/upload-scope', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 30000,  // 202 comes back in ~3s (parse PDF + DB write); GPT runs in background
  }).then(r => r.data);

// ── Evaluate ──────────────────────────────────────────────────────────────────
// data: { projectId, selectedText, tone? }  — tone is optional; Pro/Teams only
export const evaluateScope = (data) => api.post('/evaluate', data, { timeout: 35000 }).then(r => r.data);
export const evaluateRequest = evaluateScope; // backwards-compat alias

// ── Scope Ledger (Pro/Teams) ──────────────────────────────────────────────────
export const getLedger           = (projectId) => api.get(`/ledger/${projectId}`).then(r => r.data);
export const createLedgerEntry   = (data) => api.post('/ledger', data).then(r => r.data);
export const updateLedgerEntry   = (id, data) => api.patch(`/ledger/${id}`, data).then(r => r.data);
export const deleteLedgerEntry   = (id) => api.delete(`/ledger/${id}`).then(r => r.data);

// ── Change Orders (Pro/Teams) ─────────────────────────────────────────────────
export const getChangeOrders     = (projectId) => api.get(`/change-orders/${projectId}`).then(r => r.data);
export const createChangeOrder   = (data) => api.post('/change-orders', data).then(r => r.data);
export const updateChangeOrder   = (id, data) => api.patch(`/change-orders/${id}`, data).then(r => r.data);
export const deleteChangeOrder   = (id) => api.delete(`/change-orders/${id}`).then(r => r.data);


// ── Health ────────────────────────────────────────────────────────────────────
export const getHealth = () => api.get('/health').then(r => r.data);

// ── Account ───────────────────────────────────────────────────────────────────
export const deleteAccount = () => api.delete('/auth/account').then(r => r.data);

// ── Waitlist ──────────────────────────────────────────────────────────────────
export const joinWaitlist = (data) => api.post('/waitlist', data).then(r => r.data);

export default api;
